import createStyles from '@mui/styles/createStyles';

export default () =>
  createStyles({
    root: {
      whiteSpace: 'nowrap',
    },
  });
